<template>
<div class="integration-app">
	<!-- <div class="integration-app"> -->
		<div class="wrapper">
			<div class="integration-app-logo">
				<div class="text">{{ $t("Warehouse") }}</div>
			</div>
			<!-- <button
				type="button"
				class="integration-app-button btn btn-primary"
				@click="openFormWarehouse('add')"
			>
				+ <span class="ml-2">{{ $t("Add Warehouse") }}</span>
			</button> -->
		</div>
	<!-- </div> -->
</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'SettingWarehouseSectionHeader',
	components: {
		// WarehouseForm,
	},
	data() {
		return {
			isShowFormWarehouse: false,
			warehouseFormType: '',
		};
	},
	methods: {
		...mapActions({
			storeNewWarehouse: 'warehouse/storeNewWarehouse',
		}),
		/**
		 * Open Modal Form Add Warehouse
		 *
		 * @param {String} type
		 * @this {String} warehouseFormType
		 * @this {Boolean} isShowFormWarehouse
		 */
		openFormWarehouse(type) {
			this.warehouseFormType = type;
			this.isShowFormWarehouse = true;
		},
		/**
		 * Add new Warehouse
		 *
		 * @param {Object} warehouses
		 * @this {Funtion} updateWarehouse
		 */
		addNewWarehouse(warehouses) {
			this.storeNewWarehouse(warehouses);
		},
	},
};
</script>

<style></style>
